$(document).ready(function () {

    /*
        // Sticky nav changes once scrolled
        var header = $(".header");

        $('[canvas=container]').scroll(function() {
           var scroll = $('[canvas=container]').scrollTop();
           if (scroll >= 50) {
               header.addClass("scrolled");
           } else {
               header.removeClass("scrolled");
           }
        });
    */

    // category filters on programs/disorders pages
    $('.filter-link').click(function (event) {
        event.preventDefault();

        var cat = $(this).data('category');
        $('.filter-link').removeClass('active');
        $(this).addClass('active');
        $('.empty-result').hide();

        if (cat === 'all') {
            $('.result').fadeIn();
        }
        else {
            $('.result').hide();
            var n = $('.result[data-category*=' + cat + ']').length;
            $('.result[data-category*=' + cat + ']').fadeIn();

            if (n === 0) {
                $('.empty-result').fadeIn();
            }
        }

    });

});

(function ($) {
    // Initialize Slidebars
    var controller = new slidebars();
    controller.init();

    $('.toggle-id-offCanvas').on('click', function (event) {
        // Stop default action and bubbling
        event.stopPropagation();
        event.preventDefault();
        controller.toggle('id-offCanvas');
    });

    // Close any
    $(document).on('click', '.js-close-any', function (event) {
        if (controller.getActiveSlidebar()) {
            event.preventDefault();
            event.stopPropagation();
            controller.close();
        }
    });

    // Add close class to canvas container when Slidebar is opened
    $(controller.events).on('opening', function () {
        $('[canvas]').addClass('js-close-any');
    });

    // Add close class to canvas container when Slidebar is opened
    $(controller.events).on('closing', function () {
        $('[canvas]').removeClass('js-close-any');
    });

    $(document.getElementById('quantity-input')).on('change blur', function () {

        if (!this.value || this.value < 0) { this.value = 0; }

        $(document.getElementById('update-quantity-btn')).removeAttr('style');
    });

})(jQuery);



document.addEventListener("DOMContentLoaded", () => {
  const contactForm = document.getElementById("CRMForm");
  const formOutput = document.getElementById("formOutput");
  const submitBtn = document.getElementById("submitBtn");
  if (!contactForm || !formOutput) return;

  contactForm.addEventListener("submit", (event) => {
    event.preventDefault();
    event.stopPropagation();

    contactForm.style.opacity = "0.6";
    contactForm.style.transition = "opacity 0.3s ease";
    submitBtn.disabled = true;
    submitBtn.innerHTML =
      '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Sending...';

    const firstName = document.getElementById("firstName").value;
    const lastName = document.getElementById("lastName").value;
    const jobTitle = document.getElementById("jobTitle").value;
    const email = document.getElementById("email").value;
    const phone = document.getElementById("phone").value;
    const organization = document.getElementById("organization").value;
    const coordinationInfo = document.getElementById("coordinationInfo").value;
    const hearAbout = document.getElementById("hearAbout").value;
    const trainingNeeds = document.getElementById("trainingNeeds").value;
    const targetAudience = document.getElementById("targetAudience").value;
    const availability = document.getElementById("availability").value;
    const additionalInfo = document.getElementById("additionalInfo").value;

    const payload = {
      EntityName: "OmnIntakeFormSubmission",
      OmnOpportunityId: "",
      OmnName: firstName,
      OmnLastName: lastName,
      OmnTitle: jobTitle,
      OmnEmail: email,
      OmnPhone: phone,
      OmnOrganizationName: organization,
      OmnOtherContacts: coordinationInfo,
      OmnHowDidYouHearServicesId: hearAbout,
      OmnHowDidYouHearOther: "",
      OmnCurrentTrainingNeedsId: trainingNeeds,
      OmnCurrentNeedsOther: "",
      OmnAudience: targetAudience,
      OmnMeetingAvailability: availability,
      OmnAdditionalInfo: additionalInfo,
    };

    formOutput.innerHTML = "";
    fetch(
      "https://webhooks.creatio.com/webhooks/9c32a51f-e27a-4c16-8f87-f771fec3486d",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    )
      // Pause for 1000ms to simulate slow response
      .then(
        (response) =>
          new Promise((resolve) => {
            setTimeout(() => {
              resolve(response);
            }, 1000);
          })
      )
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        console.log("response", response);
        return response;
      })
      .then(() => {
        submitBtn.disabled = false;
        submitBtn.innerHTML = "SUBMIT";
        contactForm.style.opacity = "1";
        formOutput.innerHTML =
          '<div class="alert alert-success crm-success-message" role="alert"><h4 class="alert-heading">Thank you!</h4><p>Your form has been submitted successfully. We will contact you soon.</p></div>';
      })
      .catch((error) => {
        contactForm.style.opacity = "1";
        submitBtn.disabled = false;
        submitBtn.innerHTML = "SUBMIT";
        submitBtn;
        const errorAlert = document.createElement("div");
        errorAlert.className = "alert alert-danger";
        errorAlert.setAttribute("role", "alert");
        errorAlert.innerHTML =
          "<strong>Error:</strong> There was a problem submitting your form. Please try again later.";

        contactForm.insertBefore(errorAlert, contactForm.firstChild);
        console.error("Form submission error:", error);
      });

    return false;
  });
});
